import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/SecurityCacheInternalResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/securityproviders`;
	}
	listProvidersByProjectId(e, t = {}) {
		return this.api.get(this.buildPath(`${n.baseUrl}/batch/project`, {
			...t,
			projectId: e
		}));
	}
	listAllProvidersByProjectId(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/project`, { projectId: e }));
	}
};
export { n as SecurityCacheInternalResource };

//# sourceMappingURL=SecurityCacheInternalResource.js.map